import svgUrl from "ni:svgr;KCJ1z9jMxmR1XJGMnruWMVdhUBbeEnmqDYt9saiU5bI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const OuterJoinMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="var(--tbl--colors--icons--transformation--primary)" fillRule="evenodd" d="M12 18.93a8 8 0 1 1 0-13.86 8 8 0 1 1 0 13.86Z" clipRule="evenodd" /><path fill="#fff" fillOpacity={0.2} fillRule="evenodd" d="M12 18.93A7.997 7.997 0 0 0 16 12a7.997 7.997 0 0 0-4-6.93A7.997 7.997 0 0 0 8 12a7.997 7.997 0 0 0 4 6.93Z" clipRule="evenodd" /></svg>;
const Memo = memo(OuterJoinMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "OuterJoinMIcon";
}